var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
const SvgSuccessCheckmark = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 209,
    height: 209,
    x: 0,
    y: 0,
    viewBox: "0 0 520 520",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    className: "",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    "data-name": "15-Checked"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 208.52,
    cy: 288.5,
    r: 176.52,
    fill: "#b0ef8f",
    opacity: 1,
    "data-original": "#b0ef8f",
    className: ""
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#009045",
    d: "m210.516 424.937-2.239-3.815c-34.2-58.27-125.082-181.928-126-183.17l-1.311-1.781 30.963-30.6 98.012 68.439c61.711-80.079 119.283-135.081 156.837-167.2C407.859 71.675 434.6 55.5 434.87 55.345l.608-.364H488l-5.017 4.468C353.954 174.375 214.1 418.639 212.707 421.093z",
    opacity: 1,
    "data-original": "#009045",
    className: ""
  })))));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgSuccessCheckmark, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/SuccessCheckmark.1a85f847.svg";
export { ForwardRef as ReactComponent };